import { FC } from 'react';

import { ImageData } from '../VariationOne';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_TAGS,
} from '../shared';

export const getWatermarkTag = (image: ImageData) =>
  image.watermarkTag ?? 'none';

interface Props {
  image: ImageData;
  imageIndex: number;
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const SettingsModal: FC<Props> = ({ image, ...props }) => (
  <SharedSettingsModal
    {...props}
    image={{ ...image, watermarkTag: getWatermarkTag(image) }}
    title="Image Parameters"
    sections={[
      {
        title: 'Watermark',
        type: 'radio',
        stateKey: 'watermarkTag',
        options: WATERMARK_TAGS,
        columns: 2,
      },
    ]}
  />
);

export default SettingsModal;
